import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ArticleSourceRecord } from 'app/_models/common/article-source/article.source.record';
import { MainService } from 'app/_services/main.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-article-source-compare',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './article-source-compare.component.html',
  styleUrl: './article-source-compare.component.scss'
})
export class ArticleSourceCompareComponent {
  item: ArticleSourceRecord;
  mainService: MainService;

  keys: string[];
  dateKeys = ['HistoryTimestamp', 'Datetime', 'Created', 'LastChecked', 'LastUpdated'];
  doNotTrackChangesKeys = ['HistoryTimestamp', 'Deleted', 'Datetime', 'Created', 'LastChecked', 'LastUpdated'];
  onClose: Subject<boolean>;

  constructor(
    private bsModalRef: BsModalRef
  ) {
  }

  ngOnInit() {
    this.onClose = new Subject();
    this.keys = this.getKeys();
  }

  getKeys(): string[] {
    return Object.keys(this.item.History[0]).slice(1);
  }

  isDateKey(key: string): boolean {
    return this.dateKeys.includes(key);
  }

  trackChange(key: string): boolean {
    return !this.doNotTrackChangesKeys.includes(key);
  }

  close() {
    this.onClose.next(true);
    this.bsModalRef.hide();
  }

}
